import { render, staticRenderFns } from "./CourseIcon.vue?vue&type=template&id=7818d782&scoped=true&"
import script from "./CourseIcon.vue?vue&type=script&lang=js&"
export * from "./CourseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7818d782",
  null
  
)

export default component.exports